import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { SuperEjecutivoGraficaComponent } from '../super-ejecutivo-grafica/super-ejecutivo-grafica.component';
import { SuperEjecutivoTablaComponent } from '../super-ejecutivo-tabla/super-ejecutivo-tabla.component';
import { separarTablasSuperEjecutivo } from '../super-ejecutivo-tabla/super-ejecutivo-tabla.util';
import { MENSAJES_GRAFICA_SUPER_EJECUTIVO } from '../super-ejecutivo.constants';
import { ISegmentoVisibleSuperEjecutivo } from '../super-ejecutivo.interface';
import { markdownSuperEjecutivoAHtml, segmentarRespuestaSuperEjecutivo } from './super-ejecutivo-markdown.util';

/**
 * Único lugar que muestra el Markdown del Super Ejecutivo (respuestas y propuestas). Separa los bloques
 * ```grafica y los dibuja con `app-super-ejecutivo-grafica` (requerimiento `super-ejecutivo-graficas`); una
 * gráfica inválida muestra su aviso sin romper el resto (RN8.1) y una que sigue llegando, mientras el mensaje
 * esté `enCurso`, el aviso de gráfica en camino (RN8.2). Sin encapsulación porque el HTML llega por
 * `innerHTML`; sus estilos van bajo la clase `super-ejecutivo-markdown`.
 */
@Component({
  selector: 'app-super-ejecutivo-markdown',
  templateUrl: './super-ejecutivo-markdown.component.html',
  styleUrl: './super-ejecutivo-markdown.component.css',
  imports: [MatIcon, MatProgressSpinner, SuperEjecutivoGraficaComponent, SuperEjecutivoTablaComponent],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuperEjecutivoMarkdownComponent {
  /** Markdown tal como lo escribió el Super Ejecutivo. */
  public readonly texto = input.required<string>();
  /** El texto sigue llegando por el stream: un bloque de gráfica abierto todavía puede cerrarse (RN8.2). */
  public readonly enCurso = input(false);

  /**
   * Las tablas van en su propio componente para poder descargarlas; mientras la respuesta sigue llegando, una tabla
   * puede estar a medias y no se ofrece descargarla.
   */
  public readonly segmentos = computed<ISegmentoVisibleSuperEjecutivo[]>(() =>
    segmentarRespuestaSuperEjecutivo(this.texto(), this.enCurso()).flatMap((segmento): ISegmentoVisibleSuperEjecutivo[] =>
      segmento.tipo === 'markdown'
        ? separarTablasSuperEjecutivo(segmento.texto).map((pedazo) =>
            pedazo.tipo === 'tabla'
              ? { tipo: 'tabla', tabla: pedazo.tabla, descargable: !this.enCurso() }
              : { tipo: 'markdown', html: markdownSuperEjecutivoAHtml(pedazo.texto) },
          )
        : [segmento],
    ),
  );

  public readonly graficaNoValida = MENSAJES_GRAFICA_SUPER_EJECUTIVO.GRAFICA_NO_VALIDA;
  public readonly graficaEnCamino = MENSAJES_GRAFICA_SUPER_EJECUTIVO.GRAFICA_EN_CAMINO;
}
